import http from '../common/request'

export const get = async (url, data = {}, options = {}) => {
  const res = await http.get(url, {data, ...options})
  return res.data
}

export const post = async (url, data = {}, options = {}) => {
  const res = await http.post(url, data,{ ...options})
  return res.data
}
